module.exports = __webpack_public_path__ + "static/covid-5f1cd36c2d51469632076e0e3ae59f0c.jpg";